// extracted by mini-css-extract-plugin
export default {"breadcrumb":"ij-z","breadcrumbItem":"jj-z","hideOnMobile":"kj-z"};